import { render, staticRenderFns } from "./ReportTransferOwnerComponent.vue?vue&type=template&id=a859c644&"
import script from "./ReportTransferOwnerComponent.vue?vue&type=script&lang=js&"
export * from "./ReportTransferOwnerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports